import { CONFIG } from '../../core/config';
import { IRow } from '../../viewmodels/runnableLookups/icell';
import { DynamicTableRow } from '../dynamic-table-row';
import { ViewModel } from '../view-model';
import { RunnableLookupColumn } from './runnableLookup-column';
import { RunnableLookupCell } from './runnableLookups-cell';
import { RunnableLookupItemState } from './runnable-lookup-item-state';
import { RunnableLookupItem } from './runnable-lookup-item';

export class RunnableLookupRow implements ViewModel, DynamicTableRow, IRow, RunnableLookupItem {
  readonly friendlyTypeNameSingular = 'RunnableLookup Row';
  readonly apiRoute: string = CONFIG.apiRoutes.RunnableLookupRows;
  readonly type = 'user-defined';

  lookupRowId: string;
  rowIndex: number;
  columns: { [key: string]: RunnableLookupCell } = {};
  lookupId: string;

  public state: RunnableLookupItemState = RunnableLookupItemState.Unchanged;

  addColumn(column: RunnableLookupColumn, cell: RunnableLookupCell) {
    if (this.columns[column.lookupColumnId]) {
      return;
    }

    this.columns[column.lookupColumnId] = cell;
  }

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.lookupRowId = data.lookupRowId;
    this.rowIndex = data.rowIndex;

    if (data.lookupCells) {
      data.lookupCells.forEach(cell => {
        const newCell = new RunnableLookupCell();
        newCell.loadFromJson(cell);
        this.columns[cell.lookupColumnId] = newCell;
      });
    }

    this.lookupId = data.lookupId;
  }
}
